
const compareModal = document.querySelector('.compare-modal-wrapper');

const LOCAL_STORAGE_CLIENT_NAME = window.Shopify.shop.replace(/.myshopify.com/g,'');
const LOCAL_STORAGE_KEY = LOCAL_STORAGE_CLIENT_NAME + '__selected_device';

let selectedDevice = localStorage.getItem( LOCAL_STORAGE_KEY );
const compare_select = compareModal.querySelector('#compareDeviceSelect');
let productDeviceSelector = document.querySelector('#main-product #choose-device select');
let collectionDeviceSelector = document.querySelector('.mous-device-sub-collections #choose-device select');

const updateButtonUrls = (selectedDevice) => {
    const compareModalDeviceSliderCont = document.querySelector('.compare-modal-device-slider');
    const compareModalDeviceSliderWrap = compareModalDeviceSliderCont.querySelector('.swiper-wrapper');
    const compareModalDeviceSlides = compareModalDeviceSliderWrap.querySelectorAll('.case-type-card.swiper-slide');

    compareModalDeviceSlides.forEach((compareModalDeviceSlide) => {
        const compareModalDevicecBtn = compareModalDeviceSlide.querySelector('.case-study-btn');
        const compareModalDevicecHref = compareModalDevicecBtn.href.includes('?') ? compareModalDevicecBtn.href.split('?')[0] : compareModalDevicecBtn.href;
        const urlFilter = `filter-device-${selectedDevice.replace(/\s+/g, '+')}`;
        compareModalDevicecBtn.href = `${compareModalDevicecHref}?filter.p.tag=${urlFilter}`;
    });
};

// console.log('SELECTED DEVICE START: ', selectedDevice );
if ( collectionDeviceSelector && collectionDeviceSelector.value != '' ) {
    localStorage.setItem( LOCAL_STORAGE_KEY, collectionDeviceSelector.value.replace('filter-device-', '') );
    selectedDevice = collectionDeviceSelector.value.replace('filter-device-', '');
    // console.log('🚀🚀🚀 Collection page has a device selector... ', collectionDeviceSelector)
    
} else if ( productDeviceSelector && productDeviceSelector.value != '' ) {
    localStorage.setItem( LOCAL_STORAGE_KEY, productDeviceSelector.value );
    selectedDevice = productDeviceSelector.value;
    // console.log('🚀🚀🚀 Product page has a device selector... ', productDeviceSelector)
    
} else if ( productDeviceSelector && compare_select?.value ) {
    let valueExists = false;
    
    // Iterate through each option in the select element
    for (var i = 0; i < productDeviceSelector.options.length; i++) {
        if (productDeviceSelector.options[i].value === compare_select?.value) {
            valueExists = true;
            break; // Exit loop early if the value is found
        }
    }
    
    if ( valueExists ) {
        productDeviceSelector.value = compare_select?.value;
        productDeviceSelector.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        // console.log('🚀🚀🚀 Updating product select with value...')
    }
} else if ( !selectedDevice ) {
    localStorage.setItem( LOCAL_STORAGE_KEY, '' );
    selectedDevice = '';
    // console.log('NOT A SELECTED DEVICE.');
}

if ( compareModal ) {
    
    let isActive = false;
    document.body.addEventListener('click', (e) => {
        const target = e.target;
        
        if ( target.closest('[open-compare-modal]') || target.closest('[href="#open-compare-modal"]') ) {
            e.preventDefault();
            compareModal.classList.add('modal-open');
            // console.log('🚀🚀🚀 Clicked features trigger!');
            
            
            if ( !isActive ) {
                isActive = true;
                const swiperCompareModal = new window.swiper('.compare-modal-device-slider.swiper', {
                    slidesPerView: 1.2,
                    spaceBetween: 22,
                    
                    breakpoints: {
                        576: {
                            slidesPerView: 1.7,
                        },
                        768: {
                            slidesPerView: 2.4,
                        },
                        992: {
                            slidesPerView: 3.4,
                        }
                    },
                    
                    
                    navigation: {
                        nextEl: '.compare-modal-device-slider.swiper .swiper-button-next.compare-modal-device-slider-navigation',
                        prevEl: '.compare-modal-device-slider.swiper .swiper-button-prev.compare-modal-device-slider-navigation',
                    },
                    
                    on: {
                        afterInit: function () {
                            const modal = this.el.closest('aside.compare-modal-outer');
                            const compare_select = modal.querySelector('#compareDeviceSelect');
                            const case_type_slides = this.slides;
                            
                            const filterSlides = ( device ) => {
                                case_type_slides.forEach( case_type => {
                                    const case_type_compatibility = case_type.dataset.compatibleDevices.split(',');
                                    if ( case_type_compatibility.includes( device ) || device == '' ) {
                                        // console.log( 'Found Device... ', device );
                                        case_type.classList.remove('incompatible-device');
                                    } else {
                                        // console.log( 'Did Not Find Device... ', case_type_compatibility );
                                        case_type.classList.add('incompatible-device');
                                    }
                                });
                                
                                this.slideTo( 0 );
                                this.update();
                                // console.log( 'Updating Swiper...');
                            };
                            
                            if ( compare_select && modal ) {
                                compare_select.addEventListener( 'change', () => {
                                    filterSlides( compare_select.value );
                                    
                                    let selectedDeviceLocalStorage = localStorage.getItem( LOCAL_STORAGE_KEY );
                                    if ( compare_select.value != '' ) {
                                        localStorage.setItem( LOCAL_STORAGE_KEY, compare_select.value );
                                        selectedDeviceLocalStorage = compare_select.value;
                                        // console.log( 'SELECTED DEVICE: ', selectedDeviceLocalStorage );
                                    }
                                    
                                    productDeviceSelector = document.querySelector('#main-product #choose-device select');
                                    if ( productDeviceSelector && compare_select.value != '' ) {
                                        productDeviceSelector.value = compare_select.value;
                                        productDeviceSelector.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
                                    }
                                    
                                    /*
                                    collectionDeviceSelector = document.querySelector('.mous-device-sub-collections #choose-device select');
                                    if ( collectionDeviceSelector && compare_select.value != '' ) {
                                        collectionDeviceSelector.value = `filter-device-${ compare_select.value }`;
                                        collectionDeviceSelector.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
                                    }
                                    */
                                });
                                
                                if ( localStorage.getItem( LOCAL_STORAGE_KEY ) ) compare_select.value = localStorage.getItem( LOCAL_STORAGE_KEY );
                            }
                            
                            compare_select.dispatchEvent( new Event('change') );
                        }
                    }
                    
                });
                
            }
            
            if ( compare_select && compareModal ) {
                
                collectionDeviceSelector = document.querySelector('.mous-device-sub-collections #choose-device select');
                if ( collectionDeviceSelector && compare_select.value != '' ) {
                    compare_select.value = collectionDeviceSelector.value.replace('filter-device-', '');
                    // console.log('🚀🚀🚀 Updating selected device value...');
                    
                    localStorage.setItem( LOCAL_STORAGE_KEY, collectionDeviceSelector.value.replace('filter-device-', '') );
                    selectedDevice = collectionDeviceSelector.value.replace('filter-device-', '');
                    compare_select.dispatchEvent( new Event('change') );
                }
                
                productDeviceSelector = document.querySelector('#main-product #choose-device select');
                if (productDeviceSelector && compare_select && compare_select.value != '') {
                    compare_select.value = productDeviceSelector.value;
                    //console.log('🚀🚀🚀 Updating selected device value...');
                    
                    localStorage.setItem( LOCAL_STORAGE_KEY, productDeviceSelector.value );
                    selectedDevice = productDeviceSelector.value;
                    compare_select.dispatchEvent( new Event('change') );

                    // gets selected variant and adds it to the link as a url query filter 
                    const compareModalDeviceSliderCont = document.querySelector('.compare-modal-device-slider');
                    const selectedDeviceFromProductSelector = productDeviceSelector.value; // Store selected device
                    updateButtonUrls(selectedDeviceFromProductSelector); // Call the function to update URLs
                }
            }
        } else if ( target.closest('[close-compare-modal]') || target.classList.contains('compare-modal-outer') ) {
            compareModal.classList.remove('modal-open');
            // console.log('🚀🚀🚀 Clicked features close!');
        }
    });

    const compareDeviceSelect = document.getElementById('compareDeviceSelect');
    // listens for a change on the compare device dropdown gets selected option and adds it to the link as a url query filter 
    if (compareDeviceSelect) {
        compareDeviceSelect.addEventListener('change', (e) => {
            const compareModalDeviceSliderCont = document.querySelector('.compare-modal-device-slider');
            const selectedcompareDeviceOption = compareDeviceSelect.options[compareDeviceSelect.selectedIndex].value;

            if (productDeviceSelector && selectedcompareDeviceOption != productDeviceSelector.value) {
                updateButtonUrls(selectedcompareDeviceOption); 
            }
        })
    }
}